export default {
  //Base url Updated
  url: 'https://api.stage.tecoguide.com/api/v1/',
  tecoPath: 'https://teco-path-api.stage.tecoguide.com/api/v1/'
};
